<template>
  <video :controls="controls" :muted="muted" :autoplay="autoplay" :loop="loop" :poster="poster" playsinline preload>
    <source :src="videoSrc" type="video/mp4">
    <source :src="videoSrc" type="video/ogg">
    Your browser does not support the video tag.
  </video>
</template>

<script>
import {videoProps} from "./VideoProps";

export default {
  name: "Video",
  props: {
    ...videoProps
  }
}
</script>

<style scoped>

</style>